import React from 'react';
import styled from 'styled-components';

export interface SidebarItem {
    id: string;
    label: string;
    iconSrc: string;                // path to your icon image
    href?: string;                  // optional URL to navigate
    onClick?: () => void;           // optional click handler
}

interface SidebarProps {
    items: SidebarItem[];
}

export const Sidebar: React.FC<SidebarProps> = ({ items }) => (
  <Dock>
    {items.map(({ id, label, iconSrc, href, onClick }) => {
      const resolvedSrc =
        /^https?:\/\//.test(iconSrc)
          ? iconSrc
          : `${process.env.PUBLIC_URL}${iconSrc.startsWith('/') ? '' : '/'}${iconSrc}`;

      const content = (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Icon src={resolvedSrc} alt={label} />
          <Caption>{label}</Caption>
        </div>
      );

      return href ? (
        <DockLink key={id} href={href} target="_blank" rel="noopener noreferrer">
          {content}
        </DockLink>
      ) : (
        <DockButton key={id} onClick={onClick}>
          {content}
        </DockButton>
      );
    })}
  </Dock>
);


// — styled components —
const Dock = styled.div`
  position: fixed;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 2147483647;
`;

const DockButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: center;
`;

const DockLink = styled.a`
  display: inline-block;
  text-decoration: none;
  color: inherit;
  text-align: center;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  image-rendering: pixelated;
`;

const Caption = styled.div`
     display: block;
  font-family: 'ChiKareGo2', monospace;
  font-size: 1rem;
  color: #fffd46; /* yellow text */
  background-color: #004f8a; /* dark blue fill */
  border: 2px solid #00c4ff; /* bright blue border */
  padding: 2px 6px; /* tight and square */
  width: fit-content;
  clip-path: polygon(
    0 3px,
    3px 0,
    calc(100% - 3px) 0,
    100% 3px,
    100% calc(100% - 3px),
    calc(100% - 3px) 100%,
    3px 100%,
    0 calc(100% - 3px)
  );
  image-rendering: pixelated;
  line-height: 1;
  margin-top: 8px; /* optional spacing from icon above */
  &:hover{
  background: #325e81ff;
  
  }
  
`;
